import { render, staticRenderFns } from "./EChipsExtensaoEtapa.vue?vue&type=template&id=20c38b90"
import script from "./EChipsExtensaoEtapa.vue?vue&type=script&lang=js"
export * from "./EChipsExtensaoEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports